import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerSettingsPage from "../pages/DsokCustomerSettingsPage";

export const dsokCustomerSettingsRoute = {
  path: "/dsok/customer-detail/:customerUrl/settings",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerSettingsPage} />
    </DsokCustomerDetailProvider>
  ),
};
